import * as React from "react";
import type { SVGProps } from "react";
const SvgParallelepipeds = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={52}
    fill="none"
    viewBox="0 0 33 52" {...props}
  >
    <path
      fill="#fff"
      stroke="#00217B"
      strokeMiterlimit={10}
      strokeWidth={0.545}
      d="m23.588 2.732.401 33.192c0 .713.417 1.355 1.062 1.683l2.354 1.17c.789.386 1.736.3 2.425-.228l1.937-1.47a2.3 2.3 0 0 0 .904-1.826V2.56L28.782 1.12a1.95 1.95 0 0 0-1.42.029z"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeDasharray="1.36 1.36"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.408}
      d="m12.323 12.578.416 31.565 4.678 2.154 3.99-2.797V12.421l-4.808-1.94zM.83 22.295l.415 26.941 4.693 1.841 3.974-2.383V22.167l-4.807-1.655z"
    />
    <path
      stroke="#00217B"
      strokeDasharray="1.36 1.36"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.408}
      d="m12.38 12.778 4.693 1.912 4.06-1.983M16.958 14.805l.23 31.493M1.001 22.483l4.693 1.627 4.075-1.684M5.808 24.137v26.827"
    />
    <path
      fill="url(#parallelepipeds_svg__a)"
      d="m23.617 2.719 4.347 1.612a.6.6 0 0 1 .402.571l.259 34.404-4.535-2.226z"
      opacity={0.7}
      style={{
        mixBlendMode: "multiply",
      }}
    />
    <path
      stroke="#00217B"
      strokeMiterlimit={10}
      strokeWidth={0.545}
      d="m28.294 4.573 4.377-1.94"
    />
    <defs>
      <linearGradient
        id="parallelepipeds_svg__a"
        x1={26.128}
        x2={26.128}
        y1={-5.187}
        y2={37.194}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgParallelepipeds;
